import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Inject,
  OnInit,
} from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";

import {
  EMAIL_BOX_FIELD,
  EMAIL_BOX_FIELD_CONTROLS,
} from "./share-email-fields";

@Component({
  selector: "im-share-email-dialog",
  templateUrl: "./share-email-dialog.component.html",
  styleUrls: ["./share-email-dialog.component.scss"],
  imports: [MatButtonModule, MatIconModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ShareEmailDialogComponent implements OnInit {
  public emailBoxField = null;
  public emailBoxFieldControl = null;
  public emailsToSend: string[] = [];

  public constructor(
    private dialogRef: MatDialogRef<ShareEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
  ) {}

  public ngOnInit(): void {
    this.emailBoxField = { ...EMAIL_BOX_FIELD };
    this.emailBoxFieldControl = { ...EMAIL_BOX_FIELD_CONTROLS };
    console.log(this.emailBoxField);
    console.log(this.emailBoxFieldControl);

    if (this.dialogData?.defaultEmails?.length) {
      this.emailBoxFieldControl.defaultEmails = this.dialogData.defaultEmails;
      this.emailsToSend = [...this.dialogData.defaultEmails];
    }
    if (!this.dialogData.allowAdditionalEmails)
      this.emailBoxField.readOnly = true;
  }

  public cancel(): void {
    this.dialogRef.close(null);
  }

  public sendDocument(): void {
    if (this.emailBoxFieldControl.defaultEmails.length > 0) {
      this.emailBoxFieldControl.defaultEmails.forEach((email) =>
        this.emailsToSend.push(email),
      );
    }
    this.dialogRef.close({
      emailsToSend: this.emailsToSend,
    });
  }

  public onEmailAdded(email: any): void {
    this.emailsToSend = [...email.detail.value];
  }
}
